// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Pokaż hasło',
    hide: 'Ukryj hasło',
    copy: 'Kopiuj',
    copied: 'Skopiowano',
    once: 'Wyświetlone tylko teraz. Skopiuj je i zachowaj w bezpiecznym miejscu.',
  },
  loading: 'Wczytuję zmianę…',
  load_failed: 'Nie udało się wczytać tej zmiany.',
  load_retry: 'Spróbuj ponownie',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'Ta zmiana pojawi się tutaj, gdy Amigo znów będzie dostępny. Nic się nie zmieniło.',
    assistant: 'Ta zmiana pojawi się tutaj, gdy asystent znów będzie dostępny. Nic się nie zmieniło.',
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'To już zostało zatwierdzone, więc nie było nic więcej do zrobienia.',
  action_failed: 'To się nie udało, więc nic się nie zmieniło. Spróbuj ponownie za chwilę.',
  removed: 'Usunięto',
  retry: 'Spróbuj ponownie',
  retry_one: 'Spróbuj ponownie: {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Zatwierdzono.',
    retried: 'Spróbowano ponownie.',
    rejected: 'Odrzucono.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Na karcie pominięto.',
  },
  done: {
    summary_one: 'Gotowe. Zastosowano {{count}} zmianę.',
    summary_few: 'Gotowe. Zastosowano {{count}} zmiany.',
    summary_many: 'Gotowe. Zastosowano {{count}} zmian.',
    summary_other: 'Gotowe. Zastosowano {{count}} zmiany.',
    skipped_one: 'Pominięto: {{count}}, nic się nie zmieniło.',
    skipped_few: 'Pominięto: {{count}}, nic się nie zmieniło.',
    skipped_many: 'Pominięto: {{count}}, nic się nie zmieniło.',
    skipped_other: 'Pominięto: {{count}}, nic się nie zmieniło.',
  },
  partial: {
    summary_one: 'Zastosowano {{applied}} z {{approved}} zmian. Nie udało się: {{count}}.',
    summary_few: 'Zastosowano {{applied}} z {{approved}} zmian. Nie udało się: {{count}}.',
    summary_many: 'Zastosowano {{applied}} z {{approved}} zmian. Nie udało się: {{count}}.',
    summary_other: 'Zastosowano {{applied}} z {{approved}} zmian. Nie udało się: {{count}}.',
    detail_one: 'Zapisano: {{applied}}. Nic nie zmieniono w pozycjach poniżej: {{count}}.',
    detail_few: 'Zapisano: {{applied}}. Nic nie zmieniono w pozycjach poniżej: {{count}}.',
    detail_many: 'Zapisano: {{applied}}. Nic nie zmieniono w pozycjach poniżej: {{count}}.',
    detail_other: 'Zapisano: {{applied}}. Nic nie zmieniono w pozycjach poniżej: {{count}}.',
  },
  stale: {
    summary: 'Zastosowano {{applied}} z {{approved}} zmian.',
    detail_one: '{{count}} pozycja została w międzyczasie zmieniona przez kogoś innego.',
    detail_few: '{{count}} pozycje zostały w międzyczasie zmienione przez kogoś innego.',
    detail_many: '{{count}} pozycji zostało w międzyczasie zmienionych przez kogoś innego.',
    detail_other: '{{count}} pozycji zostało w międzyczasie zmienionych przez kogoś innego.',
    reason:
      '{{name}} zmienił(a) to na {{value}} o {{time}}, przed zatwierdzeniem, więc zostawiłem to bez zmian. Oto ponownie, od nowej wartości:',
    decided_done:
      '{{name}} zmienił(a) to na {{value}} o {{time}}, zanim zatwierdziłeś(-aś), więc zostawiłem bez zmian. Jego nowa propozycja została zatwierdzona na własnej karcie.',
    decided_rejected:
      '{{name}} zmienił(a) to na {{value}} o {{time}}, zanim zatwierdziłeś(-aś), więc zostawiłem bez zmian. Jego nowa propozycja została odrzucona.',
    decided_replaced:
      '{{name}} zmienił(a) to na {{value}} o {{time}}, zanim zatwierdziłeś(-aś), więc zostawiłem bez zmian. Jego nowa propozycja została zastąpiona nowszą kartą.',
    decided_expired:
      '{{name}} zmienił(a) to na {{value}} o {{time}}, zanim zatwierdziłeś(-aś), więc zostawiłem bez zmian. Jego nowa propozycja wygasła.',
  },
  undo_partly_one: 'Nie można cofnąć {{count}} z nich.',
  undo_partly_few: 'Nie można cofnąć {{count}} z nich.',
  undo_partly_many: 'Nie można cofnąć {{count}} z nich.',
  undo_partly_other: 'Nie można cofnąć {{count}} z nich.',
  undone: {
    summary_one: 'Cofnięto. {{count}} zmiana wróciła do poprzedniego stanu.',
    summary_few: 'Cofnięto. {{count}} zmiany wróciły do poprzedniego stanu.',
    summary_many: 'Cofnięto. {{count}} zmian wróciło do poprzedniego stanu.',
    summary_other: 'Cofnięto. Zmiany ({{count}}) wróciły do poprzedniego stanu.',
    detail: 'Cofnięcie zapisano też w dzienniku Amigo oraz w Menu → Historia zmian.',
    partly_summary: 'Częściowo cofnięto. {{undone}} z {{count}} zmian zostało przywróconych.',
    partly_changed_one: '{{count}} zmianę ktoś zmienił w międzyczasie, więc pozostaje bez zmian.',
    partly_changed_few: '{{count}} zmiany ktoś zmienił w międzyczasie, więc pozostają bez zmian.',
    partly_changed_many: '{{count}} zmian ktoś zmienił w międzyczasie, więc pozostaje bez zmian.',
    partly_changed_other: '{{count}} zmian ktoś zmienił w międzyczasie, więc pozostają bez zmian.',
    partly_kept_one: '{{count}} był już przywrócony do poprzedniego stanu.',
    partly_kept_few: '{{count}} były już przywrócone do poprzedniego stanu.',
    partly_kept_many: '{{count}} było już przywróconych do poprzedniego stanu.',
    partly_kept_other: '{{count}} było już przywróconych do poprzedniego stanu.',
    partly_cannot_one: '{{count}} nie można cofnąć, np. usunięcia, więc pozostaje bez zmian.',
    partly_cannot_few: '{{count}} nie można cofnąć, np. usunięcia, więc pozostają bez zmian.',
    partly_cannot_many: '{{count}} nie można cofnąć, np. usunięcia, więc pozostaje bez zmian.',
    partly_cannot_other: '{{count}} nie można cofnąć, np. usunięcia, więc pozostają bez zmian.',
    partly_left_one: '{{count}} pozostaje bez zmian.',
    partly_left_few: '{{count}} pozostają bez zmian.',
    partly_left_many: '{{count}} pozostaje bez zmian.',
    partly_left_other: '{{count}} pozostaje bez zmian.',
  },
  summary: {
    group_one: '{{count}} danie: {{reason}}',
    group_few: '{{count}} dania: {{reason}}',
    group_many: '{{count}} dań: {{reason}}',
    group_other: '{{count}} dania: {{reason}}',
    group_names_more_one: '{{names}} i jeszcze {{count}}',
    group_names_more_few: '{{names}} i jeszcze {{count}}',
    group_names_more_many: '{{names}} i jeszcze {{count}}',
    group_names_more_other: '{{names}} i jeszcze {{count}}',
    average: '{{amount}} za danie średnio',
    needs_look: 'Wymaga sprawdzenia',
    nothing_else: 'Nic więcej się nie zmienia',
  },
  labels: {
    waiting: 'Oczekuje',
    skip: 'Pomiń',
    unskip: 'Cofnij pominięcie',
    approve_all: 'Zatwierdź wszystko',
    approve_one: 'Zatwierdź: {{count}}',
    approve_few: 'Zatwierdź: {{count}}',
    approve_many: 'Zatwierdź: {{count}}',
    approve_other: 'Zatwierdź: {{count}}',
    approve_all_count_one: 'Zatwierdź wszystkie ({{count}})',
    approve_all_count_few: 'Zatwierdź wszystkie ({{count}})',
    approve_all_count_many: 'Zatwierdź wszystkie ({{count}})',
    approve_all_count_other: 'Zatwierdź wszystkie ({{count}})',
    approve_row: 'Zatwierdź',
    reject: 'Odrzuć',
    reject_confirm: 'Odrzuć',
    back: 'Wstecz',
    why: {
      amigo: 'Dlaczego nie? (opcjonalnie, Amigo to przeczyta)',
      assistant: 'Dlaczego nie? (opcjonalnie, asystent to przeczyta)',
    },
    hint: 'Albo odpowiedz poniżej, aby coś zmienić.',
    show_all_one: 'Pokaż wszystkie zmiany: {{count}}',
    show_all_few: 'Pokaż wszystkie zmiany: {{count}}',
    show_all_many: 'Pokaż wszystkie zmiany: {{count}}',
    show_all_other: 'Pokaż wszystkie zmiany: {{count}}',
    show_less: 'Pokaż mniej',
    applying_one: 'Stosuję {{count}} zmianę…',
    applying_few: 'Stosuję {{count}} zmiany…',
    applying_many: 'Stosuję {{count}} zmian…',
    applying_other: 'Stosuję zmiany: {{count}}…',
    high_impact: 'Duży wpływ',
    done: 'Gotowe',
    running: 'W toku',
    show_changes: 'Pokaż zmiany',
    hide_changes: 'Ukryj zmiany',
    rows: {
      skipped: 'Pominięto',
      applied: 'Zastosowano',
      failed: 'Nie zastosowano',
      changed: 'Zmieniono w międzyczasie',
      kept: 'Zostawiono bez zmian',
    },
    history: {
      amigo: 'Otwórz w dzienniku Amigo',
      assistant: 'Otwórz w dzienniku asystenta',
    },
    undo: 'Cofnij',
    to: 'na',
    from: 'z',
    rejected: 'Odrzucono',
    replaced: 'Zastąpiono',
    expired: 'Wygasło',
  },
};
